import { useRegisterSW } from "virtual:pwa-register/react";

export interface AppUpdate {
  /** A new service worker is waiting — a refresh will activate it. */
  needRefresh: boolean;
  /** Activate the waiting SW and reload once. */
  update: () => void;
}

// Wraps the plugin's virtual hook into a small, testable surface. UpdatePrompt
// depends on THIS (a real module), so tests mock it without touching the
// virtual SW-registration module.
export function useAppUpdate(): AppUpdate {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW();
  return { needRefresh, update: () => void updateServiceWorker(true) };
}
